import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { User } from 'projects/core/src/lib/login/data/user';
import { PayPeriod } from '../../../data/pay-period';
import { TimeCardService } from '../../../data/time-card.service';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { timer } from 'rxjs';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { TimeCard } from '../../../data/time-card';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { TimesheetEditDialogComponent } from 'projects/desktop/src/app/modules/timesheets/view/timesheet-edit-dialog/timesheet-edit-dialog.component';
import { VacationDayDialogComponent } from 'projects/desktop/src/app/modules/timesheets/view/vacation-calendar/vacation-day-dialog/vacation-day-dialog.component';
import { UsersService } from '../../../../users/data/users.service';
import { AppStateStore } from 'projects/desktop/src/app/data/app-state.store';
import { VacationStats } from '../../../data/vacation-stats';
import { VacationDay } from 'projects/desktop/src/app/modules/timesheets/view/vacation-calendar/data/vacation-day';

class StartEndPeriod {
    start: string;
    end: string;
}

@Component({
    selector: 'app-vacation-period',
    templateUrl: './vacation-period.component.html',
    styleUrls: ['./vacation-period.component.scss']
})
export class VacationPeriodComponent implements OnInit, OnDestroy {
    currentUser: User;
    cards: TimeCard[];

    activeIndex = 0;

    @Output() updatePayPeriod = new EventEmitter<StartEndPeriod>();

    timeCards: VacationDay[];

    timeCardsMap = new Map<string, TimeCard[]>();

    sheetLoading = true;

    vacationStats: VacationStats;
    usedSickDays: number;

    constructor(
        private timeCardsService: TimeCardService,
        protected usersSerivce: UsersService,
        private appStateQuery: AppStateQuery,
        private appStateStore: AppStateStore,
        protected dialog: MatDialog
    ) { }

    ngOnInit() {
        this.appStateQuery.currentUser$.subscribe(currentUser => {
            this.currentUser = currentUser;
            this.getAvailableDays();
        });

    }

    getAvailableDays() {
        this.timeCardsService.getAvailableDaysForUser(this.currentUser.id).subscribe(days => {
            this.vacationStats = days
            this.getCards()
        })
    }

    getCards() {
        this.timeCardsService.getLastVacationCardsForUser(this.currentUser.id).subscribe(timecards => {
            this.timeCards = timecards
            this.sheetLoading = false;
        })
    }

    openSheetDialog(timeCard: VacationDay) {
        if (!timeCard.approved && !timeCard.rejected) {
            const dialogRef = this.dialog.open(TimesheetEditDialogComponent, {
                data: {
                    timeCard: {
                        id: timeCard.id,
                        approved: timeCard.approved,
                        startTime: timeCard.startTime,
                        type: 'VACATION'
                    } as TimeCard,
                    buttonLabel: 'Save'
                },
                disableClose: true,
                panelClass: 'time-sheet-edit-dialog'
            });

            dialogRef.afterClosed().subscribe(result => {
                this.getCards();
            });
        }
    }

    onTabChanged(e) {
        this.activeIndex = e.index
    }

    checkLate(timeCard: VacationDay) {
        const today = moment().startOf('day');
        const startDay = moment(timeCard.startTime).startOf('day');
        if (!startDay.isAfter(today)) {
            return true
        }
        return false
    }

    requestVactions(type: string) {
        const dialogRef = this.dialog.open(VacationDayDialogComponent, {
            data: {
                type,
                buttonLabel: 'Request'
            },
            disableClose: false,
            panelClass: 'vacation-calendar-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.getAvailableDays();
            this.updateUser();
        });
    }

    openRequestDialog() {
        const dialogRef = this.dialog.open(VacationDayDialogComponent, {
            data: {
                type: 'VACATION',
                buttonLabel: 'Request'
            },
            disableClose: false,
            panelClass: 'vacation-calendar-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.getAvailableDays();
            this.updateUser();
        });
    }

    updateUser() {
        this.usersSerivce.getUser(this.currentUser.id).subscribe(user => {
            this.appStateStore.updateCurrentUser(user);
        })
    }

    getVacationTypeLabel(type: string): string {
        if (type === 'SICK_HOURS') {
            return 'Sick';
        } else if (type === 'VACATION') {
            return 'PTO';
        } else if (type === 'UNPAID_VACATION') {
            return 'Unpaid';
        }
        return '';
    }

    getVacationTypeClass(type: string): string {
        if (type === 'SICK_HOURS') {
            return 'sick-type-label';
        } else if (type === 'VACATION') {
            return 'vacation-type-label';
        } else if (type === 'UNPAID_VACATION') {
            return 'unpaid-type-label';
        }
        return '';
    }

    ngOnDestroy() {

    }
}
